import { ExamModel } from "../examination";
import { TestSubmissionModel } from "../submission";
import { Test } from "../tests";
import { Auditable } from "./auditable.class";

export class Exam extends Auditable implements ExamModel {
  id: string;
  title: string;
  description: string;
  type: string;
  classId: number;
  duration: number;
  dueDate?: Date;
  testSubmissions: TestSubmissionModel[];
  test: Test;

  // Flattened StatisticExam fields
  totalQuestion: number;
  totalPoint: number;
  totalDuration: number;

  constructor(data: ExamModel) {
    super(data);

    this.id = data.id;
    this.title = data.title;
    this.type = data.type;
    this.description = data.description;
    this.classId = data.classId;
    this.duration = data.duration;
    this.dueDate = data.dueDate ? new Date(data.dueDate) : undefined;
    this.testSubmissions = data.testSubmissions || [];
    this.test = data.test;

    this.totalQuestion = data.totalQuestion;
    this.totalPoint = data.totalPoint;
    this.totalDuration = data.totalDuration;
  }

  isPastDueDate(): boolean {
    if (!this.dueDate) return false;
    return new Date().getTime() > this.dueDate.getTime();
  }

  getSkillNames(resolverFn: (id: string) => { masterSkill: string; skill: string }): string {
    const defaultSkillName = 'General';
    if (!this.test.skillId) {
      const resolvedMasterSkill = resolverFn(this.test.masterSkillId);

      if (resolvedMasterSkill) {
        return resolvedMasterSkill.masterSkill;
      } else {
        return defaultSkillName;
      }
    }

    const resolved = resolverFn(this.test.skillId);

    if (!resolved.skill) return defaultSkillName;

    const fullDisplayName = resolved.masterSkill ? `${resolved.masterSkill} ➔ ${resolved.skill}` : resolved.skill;

    return fullDisplayName;
  }
}
